import { OrbState } from '@/components/ui/orb-state';
import type { ErrorVariant, UpgradeVariant } from './fallbackVariants';

type UpgradeProps = {
  variant: UpgradeVariant;
  onReload: () => void;
  onBack: () => void;
};

export function UpgradeFallbackScreen({ variant, onReload, onBack }: UpgradeProps) {
  const artStyle = { objectPosition: variant.objectPosition };

  if (variant.layout === 'bleed') {
    return (
      <div className="tk-fb tk-fb-bleed" role="alert">
        <img className="tk-fb-bleed__art" src={variant.image} alt="" style={artStyle} />
        <div className="tk-fb-bleed__shade" />
        <div className="tk-fb-bleed__copy">
          <span className="tk-fb-pill">
            <i className="tk-fb-dot" />
            {variant.badge}
          </span>
          <h1 className="tk-fb-title">{variant.heading}</h1>
          <p className="tk-fb-body">{variant.body}</p>
          <div className="tk-fb-bar-row">
            <div className="tk-fb-bar" aria-hidden="true">
              <span className="tk-fb-bar__fill" />
            </div>
            <OrbState state="working" size="block" label="Nieuwe versie wordt geladen" />
          </div>
          <div className="tk-fb-row">
            <button type="button" className="tk-fb-btn tk-fb-btn-primary tk-fb-btn-xl" onClick={onReload}>
              {variant.cta}
            </button>
            <button type="button" className="tk-fb-btn tk-fb-btn-ghost" onClick={onBack}>
              Go back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tk-fb tk-fb-card-wrap" role="alert">
      <article className="tk-fb-card">
        <img className="tk-fb-card__art" src={variant.image} alt="" style={artStyle} />
        <div className="tk-fb-pill">{variant.badge}</div>
        <h1 className="tk-fb-title">{variant.heading}</h1>
        <p className="tk-fb-body">{variant.body}</p>
        <div className="tk-fb-bar-row">
          <div className="tk-fb-bar" aria-hidden="true">
            <span className="tk-fb-bar__fill" />
          </div>
          <OrbState state="working" size="block" label="Nieuwe versie wordt geladen" />
        </div>
        <div className="tk-fb-row">
          <button type="button" className="tk-fb-btn tk-fb-btn-primary" onClick={onReload}>
            {variant.cta}
          </button>
          <button type="button" className="tk-fb-btn tk-fb-btn-ghost" onClick={onBack}>
            Go back
          </button>
        </div>
      </article>
    </div>
  );
}

type ErrorProps = {
  variant: ErrorVariant;
  error: Error | null;
  reported: boolean;
  onReload: () => void;
  onBack: () => void;
};

export function RealErrorFallbackScreen({
  variant,
  error,
  reported,
  onReload,
  onBack,
}: ErrorProps) {
  return (
    <div className="tk-fb tk-fb-card-wrap" role="alert">
      <article className="tk-fb-card">
        <img
          className="tk-fb-card__art"
          src={variant.image}
          alt=""
          style={{ objectPosition: variant.objectPosition }}
        />
        <div className="tk-fb-pill tk-fb-pill--warn">{variant.badge}</div>
        <h1 className="tk-fb-title">{variant.heading}</h1>
        <p className="tk-fb-body">{variant.body}</p>
        {error && (
          <details className="tk-fb-errbox">
            <summary>What happened</summary>
            <pre>
              {error.message}
              {error.stack ? `\n${error.stack.split('\n').slice(0, 10).join('\n')}` : ''}
            </pre>
          </details>
        )}
        <div className="tk-fb-row">
          <button type="button" className="tk-fb-btn tk-fb-btn-primary" onClick={onReload}>
            Reload
          </button>
          <button type="button" className="tk-fb-btn tk-fb-btn-ghost" onClick={onBack}>
            Go back
          </button>
        </div>
        {reported && <p className="tk-fb-note">The team has been notified</p>}
      </article>
    </div>
  );
}
